// src/api/quotationApi.js
import { getAuthHeader } from "../Utils/auth";
import { path_url } from "../Config/config";

const h = () => ({
  "Content-Type": "application/json",
  ...getAuthHeader()
});

const BASE = `${path_url}/quotation`;

// ── Core Quotation ──────────────────────────────────────
export const generateFromPO = (poId) =>
  fetch(`${BASE}/generate-from-po/${poId}`, { method: "POST", headers: h() });

export const listQuotations = (status) =>
  fetch(`${BASE}${status ? `?status=${status}` : ""}`, { headers: h() });

export const getQuotationById = (id) =>
  fetch(`${BASE}/${id}`, { headers: h() });

export const updateQuotation = (id, body) =>
  fetch(`${BASE}/${id}`, {
    method: "PUT",
    headers: h(),
    body: JSON.stringify(body)
  });

export const changeStatus = (id, status) =>
  fetch(`${BASE}/${id}/status`, {
    method: "PATCH",
    headers: h(),
    body: JSON.stringify(status)   // sends "APPROVED" as raw JSON string
  });

export const generateInvoice = (id) =>
  fetch(`${BASE}/${id}/generate-invoice`, { method: "POST", headers: h() });

export const deleteQuotation = (id) =>
  fetch(`${BASE}/${id}`, { method: "DELETE", headers: h() });

// ── Related Data ────────────────────────────────────────
export const getBillingAddress = (quotationId) =>
  fetch(`${BASE}/billingaddress/quotationid/${quotationId}`, { headers: h() });

export const getShippingAddress = (quotationId) =>
  fetch(`${BASE}/shippingaddress/quotationid/${quotationId}`, { headers: h() });

export const getItems = (quotationId) =>
  fetch(`${BASE}/items/quotationid/${quotationId}`, { headers: h() });

export const deleteItem = (itemId) =>
  fetch(`${BASE}/items/remove/${itemId}`, { method: "DELETE", headers: h() });

export const getProductTotal = (quotationId) =>
  fetch(`${BASE}/producttotal/quotationid/${quotationId}`, { headers: h() });

export const getSellerInfo = (quotationId) =>
  fetch(`${BASE}/sellerinfo/quotationid/${quotationId}`, { headers: h() });

// ── Helper: load all quotation detail data at once ──────
export const loadQuotationDetail = async (id) => {
  const [q, billing, shipping, items, total, seller] = await Promise.all([
    getQuotationById(id).then(r => r.json()),
    getBillingAddress(id).then(r => r.json()),
    getShippingAddress(id).then(r => r.json()),
    getItems(id).then(r => r.json()),
    getProductTotal(id).then(r => r.json()),
    getSellerInfo(id).then(r => r.json()),
  ]);
  return { quotation: q, billing, shipping, items, total, seller };
};

// ── PO Listing Helper for Generate Modal ─────────────────
export const fetchPurchaseOrders = async (adminId) => {
  const url = adminId ? `${path_url}/po/useradmin/${adminId}` : `${path_url}/po/all`;
  const res = await fetch(url, { headers: h() });
  if (!res.ok) throw new Error("Failed to fetch purchase orders");
  return res.json();
};

